<template>
  <div class="md-layout-item md-size-50 md-small-size-100 results md-elevation-1">
    <md-card-header>
      <div class="md-title">Results</div>
    </md-card-header>

    <md-content v-if="!stats" class="md-layout-item message">
      Results will show up here...
    </md-content>

    <md-table
      ref="myTable"
      v-if="stats"
      v-model="stats.records"
      md-sort="count"
      md-sort-order="desc"
      md-card
      md-fixed-header>

      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }">

        <template v-for="col of stats.colnames">
          <md-table-cell
            :md-label="col"
            :key="col"
            :md-sort-by="col"
          >{{ item[col] }}</md-table-cell>
        </template>

      </md-table-row>
    </md-table>
    <div class="md-content total">Total: {{ sumCount }}</div>
  </div>
</template>

<script>

export default {
  name: 'StatsResult',
  props: {
    stats: null,
  },
  data: () => ({
  }),
  computed: {
    sumCount() {
      let total = 0;
      if (this.stats) {
        total = this.stats.records.reduce((_total, _record) => _total + _record.count, 0);
      }
      return total;
    },
  },
  watch: {
    stats() {
      // beetje een hack oplossing nodig omdat de tabel schijnbaar niet automatisch gesorteerd
      // blijft zodra nieuwe data geladen is
      if (this.$refs && this.$refs.myTable) {
        setTimeout(() => {
          this.$refs.myTable.sortTable();
        }, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .md-title {
    font-size: 20px;
    font-weight: 200;
  }
  .results {
    background-color: #fff;
    margin: 0 1rem;
  }
  .total {
    margin: 1rem;
    font-weight: 700;
  }
  .md-table {
    margin: 0 1rem;
  }
  .message {
    margin: 0 1rem;
  }
</style>
